export default {
    language: "Русский",
    StripeSuccess: {
        loading: "Обработка вашего платежа...",
        successMessage: "Подписка успешно активирована!",
        processingError: "Ошибка обработки платежа, свяжитесь с нами",
    },
    UserDetail: {
        userInfo: {
            emailLabel: "Эл. почта",
            createdAt: "Дата создания",
            noRecord: "Нет записей",
            loginTime: "Время входа",
        },
        orders: {
            title: "История заказов",
            loading: "Загрузка...",
            refresh: "Обновить",
            orderAmount: "Сумма",
            points: "Баллы",
            createdAt: "Дата создания",
            orderType: "Тип",
            status: "Статус",
            noOrders: "Нет заказов",
            goToSubscription: "Купить баллы",
            freeCredit: "Бесплатные кредиты",
            paidCredit: "Оплаченные кредиты",
            queryOrderFailed: "Не удалось получить информацию о заказе",
            statusPaid: "Оплачен",
            statusPending: "В ожидании",
            statusCancelled: "Отменен",
            statusDeactivated: "Деактивирован",
            checkoutUrlNotAvailable: "Не удалось получить URL оплаты",
            verifyingPayment: "Проверка статуса оплаты...",
            paymentSuccess: "Оплата успешна",
            paymentPending: "Заказ ожидает оплаты, пожалуйста, завершите оплату",
            paymentFailed: "Оплата не удалась или была отменена",
            paymentStatus: "Статус оплаты",
            paymentStatusDescription: "Вы завершили оплату?",
            cancelPayment: "Отменить оплату",
            completedPayment: "Оплата завершена",
            warning: "Предупреждение",
            confirmCancelOrder: "Вы уверены, что хотите отменить этот заказ? Это действие нельзя отменить.",
            cancel: "Отмена",
            confirm: "Подтвердить",
            cancellingOrder: "Отмена заказа...",
            orderCancelledSuccess: "Заказ отменен",
            cancelOrderFailed: "Не удалось отменить заказ",
            checkOrderStatusFailed: "Не удалось проверить статус заказа",
            promptClick: "Нажмите на статус \"В ожидании\", чтобы продолжить оплату",
        }
    },
    UserFeedback: {
        title: "Отзывы пользователей",
        feedback: "Послушайте реальные оценки нашей технологии обработки изображений на базе ИИ от создателей контента и профессионалов со всего мира.",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "Г-н Линь",
                profession: "Видеомонтажёр и создатель контента",
                rating: 5,
                comment: "Потрясающе! ClixMagicAI работает молниеносно! Загрузите видео с водяным знаком, и через несколько минут вы получите версию без водяного знака, абсолютно без потери качества. Незаменимый инструмент для удаления водяных знаков!"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "Г-жа Су",
                profession: "Специалист по социальным сетям",
                rating: 5,
                comment: "ClixMagicAI спас мою библиотеку контента для Instagram! Он точно распознает сложные водяные знаки, обработка краев намного более деликатная, чем в других программах, а результат выглядит более естественно."
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "Г-н Чен",
                profession: "Продюсер короткометражного видеоконтента",
                rating: 5,
                comment: "Удаление водяных знаков с ClixMagicAI невероятно удобно. Обрабатываю материалы TikTok по дороге на работу, а как только прихожу в офис — сразу скачиваю HD-версию. Эффективность увеличивается вдвое! Настоящее спасение для медиа-профессионалов."
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "Г-н Хуанг",
                profession: "Графический дизайнер и визуальный креативный директор",
                rating: 5,
                comment: "Как дизайнер, я очень доволен! При обработке образцов изображений с логотипами клиентов фоновая текстура восстанавливается естественным образом, без следов Photoshop, что экономит уйму времени на постобработку."
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "Г-жа Эмили",
                profession: "Фрилансер по созданию цифрового контента",
                rating: 5,
                comment: "Я нашла настоящее сокровище! Цена подписки гораздо ниже, чем у других продуктов для удаления водяных знаков на рынке, но эффект на самом деле лучше, особенно при обработке градиентных прозрачных водяных знаков."
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "Г-н Робертсон",
                profession: "Разработчик корпоративных учебных курсов",
                rating: 5,
                comment: "ClixMagicAI очень удобен, так как не требует установки! На моем рабочем компьютере есть ограничения на установку программ, а теперь я могу обрабатывать учебные материалы прямо в браузере в любое время и в любом месте."
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "Г-жа Чжоу",
                profession: "Домохозяйка и редактор контента сообщества",
                rating: 5,
                comment: "Интерфейс настолько прост, что даже моя бабушка смогла бы его использовать! Если у вас нет времени изучать профессиональные программы вроде Photoshop, обязательно попробуйте ClixMagicAI. Идеально подходит для таких технических новичков, как я. Хаха~"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "Г-н Джонсон",
                profession: "Визуальный стратег электронной коммерции",
                rating: 5,
                comment: "ClixMagicAI невероятно мощный, может удалять изображения, видео, мелкие объекты, людей, текст и многое другое. Полный набор функций, рекомендую всем~"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "Г-жа Фанг",
                profession: "Любитель фотографии и создатель онлайн-контента",
                rating: 5,
                comment: "Вау~ Наконец-то я нашла инструмент для удаления водяных знаков, который не ухудшает качество изображения! Волшебно, как магия~ Редактирование фотографий больше не проблема! Настоятельно рекомендую!!!"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "Г-н Уильямс",
                profession: "Преподаватель онлайн-образования",
                rating: 5,
                comment: "Функция запоминания положения водяных знаков невероятно полезна! При обработке видео для серии курсов мне не нужно повторно выделять область, что экономит как минимум полчаса работы и значительно повышает эффективность подготовки к занятиям."
            }
        ]
    },
    Order: {
        purchasePoints: "Купить баллы",
        subtitle: "Выберите подходящий пакет баллов для удаления водяных знаков",
        loginReminderDesc: "Войдите, чтобы выбрать и купить баллы",
        freeTag: "Бесплатно",
        freePlan: "Бесплатный план",
        autoActivated: "Автоматически активируется после входа",
        points: "Баллы",
        autoIncluded: "Бесплатный подарок",
        discount: "Скидка",
        purchase: "Купить сейчас",
        paymentStatusDescription: "Вы завершили оплату?",
        paymentNotCompleted: "Оплата не завершена",
        queryOrderFailed: "Ошибка проверки статуса заказа",
        cancelPayment: "Отменить платеж",
        completedPayment: "Оплата завершена",
        warning: "Предупреждение",
        confirmCancelOrder: "Вы уверены, что хотите отменить заказ? Это действие нельзя отменить.",
        cancel: "Отмена",
        confirm: "Подтвердить",
        selectProductFirst: "Сначала выберите пакет",
        creatingOrder: "Создание заказа...",
        orderCreated: "Заказ успешно создан",
        createOrderFailed: "Ошибка создания заказа",
        checkoutUrlNotAvailable: "Ошибка получения ссылки для оплаты",
        cancellingOrder: "Отмена заказа...",
        orderCancelledSuccess: "Заказ отменен",
        cancelOrderFailed: "Ошибка отмены заказа",
        verifyingPayment: "Проверка статуса платежа...",
        paymentSuccess: "Платеж успешен",
        paymentPending: "Заказ ожидает оплаты, завершите платеж",
        paymentFailed: "Платеж не удался или отменен",
        checkOrderStatusFailed: "Ошибка проверки статуса заказа",
        quickStart: "Быстрый старт",
        shortTerm: "Краткосрочное использование",
        recommended: "Рекомендуемый",
        bestValue: "Лучшая ценность",
    },
    Login: {
        title: "Вход",
        subtitle: "Быстрый вход через социальные сети",
        memberTip: "Войдите, чтобы получить доступ к дополнительным функциям",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "Вход через GitHub"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "Вход через Google"
            }
        ],
        error: {
            serverError: "Ошибка сервера, попробуйте позже",
            networkError: "Ошибка сети, проверьте соединение"
        }
    },
    OAuthCallback: {
        loading: "Обработка запроса на вход",
        pleaseWait: "Подождите, проверка данных входа...",
        error: "Ошибка входа",
        backToHome: "Вернуться на главную",
        success: "Вход выполнен",
        redirecting: "Перенаправление на главную страницу..."
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "Цены",
            faq: "Часто задаваемые вопросы",
        },
        login: "Вход",
        userMenu: {
            account: "Аккаунт",
            logout: "Выход",
            credit: "Баллы",
            freeCredit: "Бесплатно",
            paidCredit: "Куплено",
            nextUpdate: "Следующее обновление баллов",
            language: "Язык",
            theme: "Тема",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    Description:{
        title: "ClixMagicAI",
        desc: "Профессиональный инструмент на базе ИИ для быстрого удаления водяных знаков с изображений и видео с естественными результатами.",
        fileTypes: {
            image: 'Удаление с изображений',
            pdf: 'Удаление с PDF',
            video: 'Удаление с видео'
        },
        marketingTags: [
            { id: "freeTrialTag", text: "Бесплатно каждый день", icon: "fa-gift" },
            { id: "imageTag", text: "Удаление с изображений", icon: "fa-image" },
            { id: "videoTag", text: "Удаление с видео", icon: "fa-video" },
            { id: "aiPoweredTag", text: "На базе ИИ", icon: "fa-robot" },
            { id: "noRegTag", text: "Войти и пользоваться", icon: "fa-user-check" },
        ],
        videoPromt: "Скоро!",
        videoDesc: "Мы разрабатываем функцию удаления водяных знаков с видео."
    },
    ProductAdv: {
        title: "Откройте мощные возможности ClixMagicAI:",
        advs: [
            {
                title: "Движок ИИ-распознавания: автоматическое определение элементов",
                desc: "Основан на алгоритмах глубокого обучения, автоматически распознает водяные знаки, текст, лица и сложные фоновые элементы в изображениях/видео. Поддерживает форматы Instagram, TikTok и других платформ.",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "Удалить водяной знак"
            },
            {
                title: "Мастер очистки изображений: быстрое удаление логотипов без потери качества",
                desc: "Точное удаление брендовых водяных знаков, дат съёмки и других мешающих элементов. ИИ автоматически восстанавливает текстуру фона, делая изображения естественными.",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "Удалить водяной знак"
            },
            {
                title: "Устранение динамических водяных знаков: удаление бегущих строк и логотипов",
                desc: "Одним кликом удаляйте плавающие кнопки YouTube, динамические водяные знаки TikTok и бегущие строки. ИИ отслеживает и обрабатывает кадр за кадром, выдавая плавное 4K видео.",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "Удалить водяной знак"
            }
        ]
    },
    Footer: {
        social: {
            title: "Связаться с нами",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:clixmagicai@gmail.com",
                    text: "clixmagicai@gmail.com"
                },
            ]
        },
        termsTitle: "Правовые положения",
        terms: [
            {
                id: 1,
                title: "Политика конфиденциальности",
                link: "/privacy"
            },
            {
                id: 2,
                title: "Условия использования",
                link: "/terms"
            },
            {
                id: 3,
                title: "Политика Cookie",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI Все права защищены."
    },
    Task: {
        image: {
            imageSupportText: 'Поддерживаются форматы jpg, jpeg, png, webp, heic, heif, максимум 10МБ на файл',
            imageFileTooLarge: 'Размер файла превышает лимит (макс. 10МБ)',
            invalidImageType: 'Неподдерживаемый формат, загрузите JPG, JPEG, PNG, WEBP, HEIC или HEIF',
            imageWillCost: 'Стоит: 1 балл',
            hiecSupportText: 'Форматы HEIC/HEIF будут автоматически конвертированы в PNG',
            hiecSuccess: 'Конвертация HEIC/HEIF успешна',
            hiecFailed: 'Ошибка конвертации HEIC/HEIF',
            processingImageTip: 'Обработка изображения, подождите...',
            guide: {
                title: 'Руководство',
                step1: 'Загрузите изображение',
                step2: 'Выделите область водяного знака или ИИ распознает его',
                step3: 'Нажмите отправить'
            }
        },
        common: {
            remaining: 'Осталось баллов',
            nextUpdate: 'Следующее обновление баллов',
            handleError: 'Ошибка обработки файла, попробуйте другой',
            uploadFailed: 'Ошибка загрузки',
            dragText: 'Перетащите файл сюда или',
            clickText: 'нажмите для загрузки',
            loginRequired: 'Войдите перед загрузкой',
            noRemainingTasks: 'Баллы исчерпаны',
            loginNow: 'Войти сейчас',
            upgradeNow: 'Купить баллы',
            taskSubmitSuccess: 'Задание отправлено',
            taskSubmitError: 'Ошибка отправки',
            taskRetrySuccess: 'Повтор отправлен!',
            taskRetryError: 'Ошибка повтора!',
            processing: 'Обработка',
            submit: 'Отправить',
            waiting: 'Ожидание',
            completed: 'Завершено',
            failed: 'Ошибка',
            cancelled: 'Отменено',
            url_not_found: 'Ошибка получения ссылки',
            deleted: 'Удалено',
            refreshSuccess: 'Список заданий обновлен',
            refreshFailed: 'Ошибка обновления списка',
            deleteSuccess: 'Задание удалено',
            deleteFailed: 'Ошибка удаления',
            waitingForCompletion: 'Дождитесь завершения текущего задания',
            loadOriginalImageFailed: 'Ошибка загрузки оригинала',
            downloadFailed: 'Ошибка скачивания',
            startingDownload: 'Начало загрузки...',
            noTasks: 'Нет заданий',
            refresh: 'Обновить',
            sort: 'Сортировать',
            noFilterTasks: 'Нет заданий {filter}',
            compare: 'Сравнить',
            originalImage: 'Оригинал',
            processedImage: 'Обработанное',
            dragToCompare: '👈 Переместите для сравнения 👉',
            cancel: "Отмена",
            delete: "Удалить",
            retry: "Повторить",
            download: "Скачать",
            createAt: "Создано",
            expiredAt: "Истекает",
        },
        video: {
            videoSupportText: 'Поддерживаются форматы mp4, mov, avi, mkv, максимум 100МБ на файл',
            videoFileTooLarge: 'Размер файла превышает лимит (макс. 100МБ)',
            invalidVideoType: 'Неподдерживаемый формат, загрузите MP4, MOV, AVI или MKV',
            videoWillCost: 'Стоит: 3 балла',
            processingVideoTip: 'Обработка видео, подождите...',
            guide: {
                step1: 'Загрузите видео',
                step2: 'Выберите тип водяного знака и область',
                step3: 'Нажмите отправить'
            },
            annotationTools: 'Инструменты разметки',
            selectType: 'Выберите тип',
            deleteAnnotation: 'Удалить разметку',
            clearAllAnnotations: 'Очистить все',
            annotationHelp: 'Помощь',
            dragTip: 'Перетащите для выделения',
            resizeTip: 'Изменить размер',
            moveTip: 'Разметку можно перемещать',
            processing: 'Обработка',
            submit: 'Отправить',
            taskSubmitSuccess: 'Задание отправлено',
            taskSubmitError: 'Ошибка отправки',
            retryTaskTip: 'Повтор успешен',
            retryFailed: 'Повтор не удался',
            uploadFailed: 'Ошибка загрузки',
            staticWatermarkDesc: 'Для статичных водяных знаков',
            normalWatermarkDesc: 'Для обычных фиксированных водяных знаков',
            dynamicWatermarkDesc: 'Для динамических водяных знаков',
            moveWatermarkDesc: 'Для водяных знаков, требующих перемещения'
        },
    },
    Router: {
        home: "Главная",
        terms: "Условия использования",
        privacy: "Политика конфиденциальности",
        cookie: "Политика использования файлов cookie",
        user: "Центр пользователя",
    },
    FAQ: {
        title: "Руководство по использованию и часто задаваемые вопросы о ClixMagicAI",
        prompt: "Возникли проблемы или вопросы? Свяжитесь с нами в любое время: clixmagicai@gmail.com",
        questions: [
            {
                id : 1,
                question: "Что такое ClixMagicAI и как он работает?",
                answer: "ClixMagicAI — это продвинутый инструмент для удаления водяных знаков на основе искусственного интеллекта. Он поддерживает автоматическое распознавание водяных знаков на изображениях и видео, а также предоставляет функцию ручной маркировки позиций водяных знаков. Для изображений поддерживается конвертация в различные форматы и гарантируется высокое качество вывода; для видео можно обрабатывать статические, динамические и даже изменяющиеся по форме водяные знаки."
            },
            {
                id : 2,
                question: "Предлагает ли ClixMagicAI бесплатное использование?",
                answer: "Да, мы предоставляем базовый бесплатный сервис с 10 баллами ежедневно! Вы можете использовать их для обработки изображений (расходуя 1 балл за операцию) или видео (расходуя 3 балла за операцию). В настоящее время покупка дополнительных баллов не поддерживается, доступны только 10 бесплатных баллов в день."
            },
            {
                id : 3,
                question: "Могу ли я приобрести дополнительные баллы?",
                answer: "На данном этапе покупка дополнительных баллов не поддерживается. Каждый пользователь может получить только 10 бесплатных баллов в день, которые автоматически обновляются на следующий день."
            },
            {
                id : 4,
                question: "Какие форматы файлов поддерживаются?",
                answer: "Для изображений мы поддерживаем форматы PNG, JPEG, JPG, WEBP, HEIC и HEIF, причем HEIC и HEIF автоматически конвертируются в PNG. Для видео поддерживаются различные форматы, включая MP4 и MOV."
            },
            {
                id : 5,
                question: "Как защищена моя конфиденциальность?",
                answer: "В ClixMagicAI мы высоко ценим конфиденциальность пользователей. Все загруженные файлы обрабатываются с шифрованием и автоматически удаляются в течение 24 часов после обработки. Мы не храним никаких пользовательских файлов или связанной информации."
            },
            {
                id : 6,
                question: "Как я могу войти в ClixMagicAI?",
                answer: "Мы поддерживаем быстрый вход через учетные записи GitHub или Google, обеспечивая безопасность вашей учетной записи и упрощая процесс регистрации."
            },
            {
                id : 7,
                question: "Насколько быстро происходит обработка?",
                answer: "Благодаря нашим высокопроизводительным серверам и оптимизированным алгоритмам ИИ, большинство задач по удалению водяных знаков с изображений может быть выполнено за 10 секунд, а удаление водяных знаков с видео может занять всего 1 минуту. Реальное время может варьироваться в зависимости от размера и сложности файла."
            },
            {
                id : 8,
                question: "Какой результат после обработки?",
                answer: "Наши модели ИИ прошли обширное обучение для интеллектуального удаления водяных знаков с изображений и видео, сохраняя при этом качество исходного контента. Независимо от того, распознан водяной знак автоматически или отмечен вручную, он эффективно удаляется, обеспечивая естественные конечные результаты без следов."
            },
            {
                id : 9,
                question: "Какой срок действия каждой задачи?",
                answer: "После завершения задачи обработанные файлы будут храниться в ClixMagicAI в течение 24 часов для загрузки. По истечении срока файлы будут автоматически удалены с наших серверов для защиты вашей конфиденциальности."
            },
            {
                id : 10,
                question: "Каково максимальное ограничение размера файла?",
                answer: "Мы принимаем файлы изображений максимальным размером 10 МБ и видеофайлы максимальным размером 100 МБ. Файлы, превышающие эти ограничения, могут потребовать сжатия или обрезки перед загрузкой."
            }
        ]
    },
    Terms: {
        "tabs": {
            "terms": "Условия использования",
            "privacy": "Политика конфиденциальности",
            "cookies": "Политика использования файлов cookie"
        },
        "lastUpdated": "Последнее обновление: 20 мая 2025 г.",
        "terms": {
            "sections": [
                {
                    "title": "1. Введение",
                    "description": "Добро пожаловать в ClixMagicAI. Использование наших услуг означает принятие этих условий использования. Пожалуйста, внимательно ознакомьтесь с ними."
                },
                {
                    "title": "2. Описание услуги",
                    "description": "ClixMagicAI предоставляет инструменты на основе ИИ для удаления водяных знаков с изображений и видео. Наши услуги предназначены для следующих законных целей:",
                    "items": [
                        "Удаление водяных знаков с вашего собственного контента",
                        "Удаление водяных знаков с контента, на изменение которого у вас есть соответствующие права",
                        "В образовательных и исследовательских целях"
                    ]
                },
                {
                    "title": "3. Обязанности пользователя",
                    "description": "Используя ClixMagicAI, вы соглашаетесь:",
                    "items": [
                        "Загружать только контент, который вы владеете или на изменение которого имеете соответствующие права",
                        "Не использовать наши услуги в незаконных целях или в нарушение любого закона",
                        "Не пытаться обойти наши меры безопасности или ограничения использования",
                        "Не использовать наши услуги для нарушения прав интеллектуальной собственности других лиц"
                    ]
                },
                {
                    "title": "4. Условия учетной записи",
                    "description": "Для использования некоторых функций наших услуг вам может потребоваться создать учетную запись. Для входа вы можете выбрать использование учетной записи Google или GitHub. Вы несете ответственность за:",
                    "items": [
                        "Поддержание безопасности вашей учетной записи",
                        "Все действия, происходящие под вашей учетной записью",
                        "Предоставление точной информации о вашей учетной записи (включая, помимо прочего, аватар, электронную почту, имя пользователя и идентификатор пользователя)"
                    ]
                },
                {
                    "title": "5. Бесплатные и платные услуги",
                    "description": "ClixMagicAI предлагает бесплатную базовую квоту и гибкие варианты покупки баллов для доступа к нашим функциям удаления водяных знаков:",
                    "items": [
                        "Базовая квота: Каждый пользователь автоматически получает 10 бесплатных баллов ежедневно, которые можно использовать для обработки контента",
                        "Правила расхода баллов: Удаление водяных знаков с изображений потребляет 1 балл за операцию, удаление водяных знаков с видео потребляет 3 балла за операцию",
                        "Покупка баллов: Вы можете выбрать покупку пакетов баллов для дополнительного использования, все приобретенные баллы действительны постоянно, без ограничений по сроку действия",
                        "Политика возврата: Из-за мгновенного и виртуального характера цифровых услуг, баллы не могут быть возвращены после успешной покупки"
                    ]
                },
                {
                    "title": "6. Права интеллектуальной собственности",
                    "description": "Сервис ClixMagicAI, включая все программное обеспечение, дизайн и контент, которые мы создали, является нашей интеллектуальной собственностью. Вы не можете копировать, изменять или создавать производные работы на основе наших услуг без разрешения."
                },
                {
                    "title": "7. Ограничение ответственности",
                    "description": "ClixMagicAI предоставляет услугу «как есть», без каких-либо гарантий. Мы не несем ответственности за любой ущерб, возникший в результате использования вами наших услуг."
                },
                {
                    "title": "8. Изменения в условиях",
                    "description": "Мы можем изменять эти условия в любое время. Продолжение использования ClixMagicAI после изменения условий означает, что вы принимаете измененные условия."
                },
                {
                    "title": "9. Прекращение",
                    "description": "Мы оставляем за собой право немедленно прекратить или приостановить ваш доступ к нашим услугам без предварительного уведомления, если мы считаем, что ваше поведение нарушает эти условия или наносит вред другим пользователям, нам самим или третьим лицам."
                },
                {
                    "title": "10. Применимое право",
                    "description": "Эти условия регулируются применимыми законами в месте регистрации нашей компании, независимо от положений о коллизии правовых норм."
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. Введение",
                    "description": "В ClixMagicAI мы ценим вашу конфиденциальность и обязуемся защищать ваши личные данные. Эта Политика конфиденциальности объясняет, как мы собираем, используем и защищаем вашу информацию при использовании нашего веб-сайта и услуг. Получая доступ к нашему веб-сайту или используя любую из наших услуг, вы соглашаетесь с практикой обработки данных, описанной в этой политике. Мы соблюдаем применимые правила защиты данных."
                },
                {
                    "title": "2. Информация, которую мы собираем",
                    "description": "Мы можем собирать следующие типы информации:",
                    "items": [
                        { "bold": "Информация учетной записи", "text": "Аватар пользователя, адрес электронной почты, имя пользователя и идентификатор пользователя, предоставленные при входе через Google или GitHub" },
                        { "bold": "Данные об использовании", "text": "Информация о том, как вы используете наши услуги, включая доступ к функциям и время использования" },
                        { "bold": "Загруженный контент", "text": "Изображения или видео, которые вы загружаете для обработки" },
                        { "bold": "Информация о платеже", "text": "Информация о платеже при покупке подписок (безопасно обрабатывается через сторонние платежные шлюзы, такие как Creem/Stripe/PayPal, мы храним только записи о статусе платежа)" },
                        { "bold": "Технические данные", "text": "IP-адрес, тип браузера, информация об устройстве" }
                    ]
                },
                {
                    "title": "3. Как мы используем вашу информацию",
                    "description": "Мы используем вашу информацию для:",
                    "items": [
                        { "text": "Предоставления, поддержания и улучшения наших услуг" },
                        { "text": "Обработки и завершения транзакций" },
                        { "text": "Отправки технических уведомлений и сообщений поддержки" },
                        { "text": "Ответа на ваши комментарии и вопросы" },
                        { "text": "Анализа моделей использования для улучшения пользовательского опыта и обработки личных данных только в той мере, которая необходима для достижения целей услуги" },
                        { "text": "Обеспечения того, чтобы период хранения личных данных не превышал необходимое время" },
                        { "text": "Предотвращения мошенничества или незаконной деятельности" }
                    ]
                },
                {
                    "title": "4. Безопасность данных",
                    "description": "Мы внедряем меры безопасности, соответствующие отраслевым стандартам, для защиты вашей личной информации:",
                    "items": [
                        { "text": "Шифрование AES-256 для файлов во время передачи и хранения" },
                        { "text": "Обработка конфиденциальных данных с использованием архитектуры с нулевым знанием" },
                        { "text": "Ежедневные аудиты журналов безопасности и сканирование уязвимостей" },
                        { "text": "Доступ сотрудников следует принципу минимальных привилегий" }
                    ]
                },
                {
                    "title": "5. Обмен данными",
                    "description": "Мы не продаем вашу личную информацию. Мы можем обмениваться информацией с:",
                    "items": [
                        { "bold": "Поставщики услуг", "text": "Ограничено обработкой данных, необходимой для предоставления конкретных услуг (таких как облачное хранилище CloundFlare, сторонние платежные шлюзы, такие как Creem/Stripe/PayPal), которые должны подписать соглашения об обработке данных" },
                        { "bold": "Юридические требования", "text": "Когда мы получаем действительную повестку в суд, судебный приказ или другой юридический процесс, применимый к нам" }
                    ]
                },
                {
                    "title": "6. Ваши права",
                    "description": "В соответствии с законами, применимыми в вашем регионе, у вас могут быть следующие права:",
                    "items": [
                        { "text": "Доступ к копии ваших личных данных" },
                        { "text": "Исправление неточной или неполной информации" },
                        { "text": "Право на удаление данных ('право на забвение'), если у нас нет законных оснований для их хранения" },
                        { "text": "Возражение или ограничение определенных типов обработки данных" },
                        { "text": "Право на переносимость данных, вы можете запросить передачу ваших данных" }
                    ]
                },
                {
                    "title": "7. Конфиденциальность детей",
                    "description": "Наши услуги не предназначены для лиц младше 16 лет. Согласно статье 8 Общего регламента по защите данных (GDPR), согласие для детей младше 16 лет должен предоставлять родитель или опекун. Если вам станет известно, что несовершеннолетний младше 16 лет предоставил нам личную информацию, пожалуйста, немедленно свяжитесь с нами по адресу clixmagicai@gmail.com."
                },
                {
                    "title": "8. Изменения в этой политике",
                    "description": "Мы можем периодически обновлять эту Политику конфиденциальности. Мы уведомим вас о любых существенных изменениях, опубликовав новую политику на этой странице и обновив дату «последнего обновления». Для важных изменений мы будем уведомлять пользователей по электронной почте или другим заметным способом."
                },
                {
                    "title": "9. Свяжитесь с нами",
                    "description": "Если у вас есть какие-либо вопросы об этой Политике конфиденциальности, пожалуйста, свяжитесь с нами по адресу clixmagicai@gmail.com. Если вы считаете, что ваши данные обрабатываются ненадлежащим образом или у вас есть какие-либо опасения, не стесняйтесь обращаться к нам в любое время."
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. Что такое файлы cookie",
                    "description": "Файлы cookie — это небольшие текстовые файлы, которые размещаются на вашем компьютере или мобильном устройстве при посещении веб-сайта. Они позволяют веб-сайтам распознавать ваше устройство и запоминать, посещали ли вы сайт ранее."
                },
                {
                    "title": "2. Как мы используем файлы cookie",
                    "description": "ClixMagicAI использует файлы cookie для нескольких целей:",
                    "items": [
                        { "bold": "Необходимые файлы cookie", "text": "Требуются для базовой функциональности нашего веб-сайта (такой как управление сессиями и функции безопасности)" },
                        { "bold": "Файлы cookie предпочтений", "text": "Запоминают ваши настройки и предпочтения для улучшения вашего опыта, например, запоминая ваш аватар, имя пользователя и т. д. после входа через Google или GitHub" },
                        { "bold": "Аналитические файлы cookie", "text": "Помогают нам понять, как посетители взаимодействуют с нашим веб-сайтом, собирая анонимную информацию" },
                        { "bold": "Маркетинговые файлы cookie", "text": "Отслеживают ваши привычки просмотра для предоставления релевантной рекламы" }
                    ]
                },
                {
                    "title": "3. Типы файлов cookie, которые мы используем",
                    "subsection": [
                        {
                            "title": "3.1 Необходимые файлы cookie",
                            "description": "Эти файлы cookie необходимы для правильного функционирования веб-сайта. Они обеспечивают основные функции, такие как безопасность, управление сетью и доступ к учетной записи (включая вход через Google и GitHub). Вы можете настроить свой браузер для блокировки этих файлов cookie, но некоторые части веб-сайта могут не работать должным образом."
                        },
                        {
                            "title": "3.2 Файлы cookie для производительности и аналитики",
                            "description": "Эти файлы cookie помогают нам понять, как посетители взаимодействуют с нашим веб-сайтом, собирая анонимную информацию. Мы используем эти данные для улучшения нашего веб-сайта и услуг. Эти файлы cookie не собирают информацию, которая может идентифицировать посетителя."
                        },
                        {
                            "title": "3.3 Функциональные файлы cookie",
                            "description": "Эти файлы cookie позволяют нашему веб-сайту запоминать выбор, который вы делаете (например, предпочтения языка или статус входа), чтобы предоставить улучшенные, персонализированные функции, такие как запоминание вашего статуса входа через Google или GitHub."
                        },
                        {
                            "title": "3.4 Файлы cookie для таргетинга и рекламы",
                            "description": "Эти файлы cookie используются для показа релевантной рекламы посетителям и отслеживания эффективности наших рекламных кампаний. Обратите внимание, что поскольку наш веб-сайт в основном полагается на вход третьих лиц (Google и GitHub), этот тип файлов cookie в основном используется для улучшения пользовательского опыта, а не для прямого маркетинга."
                        }
                    ]
                },
                {
                    "title": "4. Управление файлами cookie",
                    "description": "Вы можете контролировать и управлять файлами cookie различными способами. Большинство веб-браузеров позволяют управлять настройками файлов cookie. Вы можете:",
                    "items": [
                        { "text": "Удалить файлы cookie с вашего устройства" },
                        { "text": "Блокировать файлы cookie, активируя настройки вашего браузера, которые позволяют отказаться от некоторых или всех файлов cookie" },
                        { "text": "Настроить ваш браузер так, чтобы он предупреждал вас, когда вы получаете файлы cookie" }
                    ]
                },
                {
                    "title": "5. Файлы cookie третьих сторон",
                    "description": "Некоторые файлы cookie размещаются третьими сторонами на нашем веб-сайте. Эти третьи стороны могут включать аналитические сервисы (такие как Google Analytics) и рекламные сети. Из-за того, как работают файлы cookie (файлы cookie могут быть доступны только той стороне, которая изначально их установила), мы не контролируем использование этих файлов cookie третьими сторонами и не можем получить к ним доступ. Для пользователей, которые входят через Google и GitHub, мы обеспечим соблюдение руководящих принципов конфиденциальности этих платформ при обработке связанной информации."
                },
                {
                    "title": "6. Обновление этой Политики использования файлов cookie",
                    "description": "Мы можем время от времени обновлять эту Политику использования файлов cookie, чтобы отразить изменения в технологии, правилах или наших бизнес-практиках. Любые изменения будут опубликованы на этой странице, и дата пересмотра будет обновлена."
                },
                {
                    "title": "7. Свяжитесь с нами",
                    "description": "Если у вас есть какие-либо вопросы о нашем использовании файлов cookie, пожалуйста, свяжитесь с нами по адресу clixmagicai@gmail.com."
                }
            ]
        }
    },
}